<template>
  <div class="publish-widget">
    <lang-selector
      v-model="selectedLang"
      @addNewLang="addNewLang"
      :lang-list="langList"
    />
    <div id="widget-offline" class="widget-section">
      <h3 class="primary-text text-bold">Widget Offline/Closed</h3>

      <div class="publish-input-body">
        <v-layout row wrap>
          <v-flex xs4>
            <label class="d-block">Bubble icon open</label>
            <image-input
              :small="true"
              :url="widgetParameters[selectedLang].openBubbleImage"
              @onFileUpload="
                widgetParameters[selectedLang].openBubbleImage = $event.url
              "
              @onFileRemove="
                widgetParameters[selectedLang].openBubbleImage = ''
              "
              types="image/png, image/jpg, image/jpeg"
              icon="botter-image-icon"
            ></image-input>
          </v-flex>
          <v-flex xs4>
            <label class="d-block">Bubble Icon close</label>
            <image-input
              :small="true"
              :url="widgetParameters[selectedLang].closeBubbleImage"
              @onFileUpload="
                widgetParameters[selectedLang].closeBubbleImage = $event.url
              "
              @onFileRemove="
                widgetParameters[selectedLang].closeBubbleImage = ''
              "
              types="image/png, image/jpg, image/jpeg"
              icon="botter-image-icon"
            ></image-input>
          </v-flex>
          <v-flex xs4>
            <label class="">Bubble background color</label>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].bubbleButtonColor"
                  />
                </span>
              </template>
              <span>Open chat button background color</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs4>
            <label class="">Bubble icon size</label>
            <v-text-field
              v-model="widgetParameters[selectedLang].bubbleButtonSize"
              type="number"
              min="40"
              max="200"
              step="5"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <label class="d-block">Bubble icon type</label>
            <v-radio-group
              v-model="widgetParameters[selectedLang].openBubbleImageColorType"
              row
              color="primary"
            >
              <v-radio label="White" value="white" color="primary"></v-radio>
              <v-radio
                label="Colored"
                color="primary"
                value="colored"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs4>
            <label for="">Bubble icon full width</label>
            <v-switch
              v-model="widgetParameters[selectedLang].openBubbleImageFullWidth"
            />
          </v-flex>

          <v-flex xs4>
            <label class="">Widget Position</label>
            <v-radio-group
              v-model="widgetParameters[selectedLang].position"
              row
              color="primary"
            >
              <v-radio label="Left" value="left" color="primary"></v-radio>
              <v-radio label="Right" color="primary" value="right"></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs12>
            <label for="" class="mt-4">Chat bubble icon shape</label>
            <v-btn-toggle
              v-model="widgetParameters[selectedLang].chatBubbleIconShape"
              class="chat-bubbles-icon"
            >
              <v-btn
                v-for="(btn, index) in chatBubbleIconOptions"
                :class="btn.class"
                :value="btn.value"
                :key="index"
              >
                {{ btn.name }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>

          <v-flex xs12>
            <label for="" class="mt-4">Chat bubble shape</label>
            <v-btn-toggle
              v-model="widgetParameters[selectedLang].chatBubbleShape"
              class="chat-bubbles"
            >
              <v-btn
                v-for="(btn, index) in chatBubbleOptions"
                :class="btn.class"
                :value="btn.value"
                :key="index"
              >
                {{ btn.name }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>

          <v-flex xs4f>
            <label class="">Offline message</label>
            <v-textarea
              class=""
              v-model="widgetParameters[selectedLang].offlineMessage"
              outline
            ></v-textarea>
          </v-flex>
          <v-flex xs4>
            <label for="">Offline message appearance</label>
            <v-radio-group
              v-model="widgetParameters[selectedLang].offLineMessageAppearance"
              color="primary"
            >
              <v-radio
                v-for="(appearance, index) in offLineMessageAppearanceList"
                :key="index"
                :label="appearance.name"
                :value="appearance.value"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs4>
            <label class="">Offline message colors</label>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="
                      widgetParameters[selectedLang]
                        .offLineMessageBackgroundColor
                    "
                  />
                </span>
              </template>
              <span>Offline message background color</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="
                      widgetParameters[selectedLang].offLineMessageFontColor
                    "
                  />
                </span>
              </template>
              <span>Offline message font color</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs4>
            <label>WhatsApp link</label>
            <v-text-field
              class=""
              v-model="widgetParameters[selectedLang].whatsAppChatButtonLink"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <label for="">WhatsApp display option</label>
            <v-switch
              label="Display only WhatsApp widget"
              v-model="widgetParameters[selectedLang].whatsAppMandatory"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
          </v-flex>

          <v-flex
            xs4
            v-if="widgetParameters[selectedLang].whatsAppChatButtonLink"
          >
            <label class="">Channels buttons color</label>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].whatsAppBtnColor"
                  />
                </span>
              </template>
              <span>WhatsApp button background color</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="!widgetParameters[selectedLang].whatsAppMandatory"
            >
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].webBtnColor"
                  />
                </span>
              </template>
              <span>Web button background color</span>
            </v-tooltip>
          </v-flex>

          <v-flex
            xs4
            v-if="widgetParameters[selectedLang].whatsAppChatButtonLink"
          >
            <label class="d-block">WhatsApp icon</label>
            <image-input
              :small="true"
              :url="widgetParameters[selectedLang].whatsAppBtnImg"
              @onFileUpload="
                widgetParameters[selectedLang].whatsAppBtnImg = $event.url
              "
              @onFileRemove="widgetParameters[selectedLang].whatsAppBtnImg = ''"
              types="image/png, image/jpg, image/jpeg"
              icon="botter-image-icon"
            ></image-input>
          </v-flex>

          <v-flex
            xs4
            v-if="
              !widgetParameters[selectedLang].whatsAppMandatory &&
              widgetParameters[selectedLang].whatsAppChatButtonLink
            "
          >
            <label class="d-block">Web icon</label>
            <image-input
              :small="true"
              :url="widgetParameters[selectedLang].webBtnImg"
              @onFileUpload="
                widgetParameters[selectedLang].webBtnImg = $event.url
              "
              @onFileRemove="widgetParameters[selectedLang].webBtnImg = ''"
              types="image/png, image/jpg, image/jpeg"
              icon="botter-image-icon"
            ></image-input>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <hr />

    <div id="widget-intro" class="widget-section">
      <h3 class="primary-text text-bold">Widget Intro</h3>

      <div class="publish-input-body">
        <v-layout row wrap>
          <v-flex xs4>
            <label class="">Logo</label>
            <image-input
              :small="true"
              :url="widgetParameters[selectedLang].logo"
              @onFileUpload="widgetParameters[selectedLang].logo = $event.url"
              @onFileRemove="widgetParameters[selectedLang].logo = ''"
              types="image/png, image/jpg, image/jpeg"
              icon="botter-image-icon"
            ></image-input>
          </v-flex>

          <v-flex xs4>
            <label class="d-block">Logo color type</label>
            <v-radio-group
              v-model="widgetParameters[selectedLang].logoColorType"
              row
              color="primary"
            >
              <v-radio label="White" value="white" color="primary"></v-radio>
              <v-radio
                label="Colored"
                color="primary"
                value="colored"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs4>
            <label class="">Intro colors</label>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].mainColor"
                  />
                </span>
              </template>
              <span>Actions color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].headerColor"
                  />
                </span>
              </template>
              <span>Header background color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].headerFontColor"
                  />
                </span>
              </template>
              <span>Header font color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].introButtonsColor"
                  />
                </span>
              </template>
              <span>Intro buttons font color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="
                      widgetParameters[selectedLang].introButtonsBackground
                    "
                  />
                </span>
              </template>
              <span>Intro buttons background color</span>
            </v-tooltip>
          </v-flex>

          <v-flex xs6>
            <div class="btn-group" role="group" aria-label="Basic example">
              <label class="d-block">Header</label>
              <v-textarea
                class=""
                v-model="widgetParameters[selectedLang].header"
                outline
              ></v-textarea>
            </div>
          </v-flex>
          <v-flex xs6>
            <label class="">Sub Header</label>
            <v-textarea
              class=""
              v-model="widgetParameters[selectedLang].subHeader"
              outline
            ></v-textarea>
          </v-flex>

          <v-flex xs4>
            <label>Start form button label</label>
            <v-text-field
              class=""
              v-model="widgetParameters[selectedLang].startButtonLabel"
              outline
            ></v-text-field>
            <div>
              <label>End form button label</label>
              <v-text-field
                class=""
                v-model="widgetParameters[selectedLang].endButtonLabel"
                outline
              ></v-text-field>
            </div>
          </v-flex>
          <v-flex xs4>
            <label for="">Language </label>
            <v-autocomplete
              v-model="widgetParameters[selectedLang].lang"
              :items="langIso"
              item-text="name"
              class=""
              item-value="code"
              outline
              solo
              label="Search Languages"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex xs4 class="pt-5">
            <v-switch
              label="Hide forms"
              v-model="widgetParameters[selectedLang].hideForms"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
            <v-switch
              v-model="widgetParameters[selectedLang].hideFaqs"
              label="Hide FAQs"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
            <v-switch
              label="Hide Botter"
              v-model="widgetParameters[selectedLang].hideBotter"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
            <v-switch
              label="Hide Share File"
              v-model="widgetParameters[selectedLang].hideShareFile"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
            <v-switch
              label="Hide Voice Note Recorder"
              v-model="widgetParameters[selectedLang].hideVoiceNoteRecorder"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
            <v-switch
              label="Hide Voice Call"
              v-model="widgetParameters[selectedLang].hideVoiceCall"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
            <v-switch
              label="Hide Home Nav"
              v-model="widgetParameters[selectedLang].hideHomeNav"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
            <v-switch
              v-model="widgetParameters[selectedLang].displayIntroButtons"
              label="Display intro buttons"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
          </v-flex>

          <v-flex xs4>
            <label class="">Home tab label</label>
            <v-text-field
              v-model="widgetParameters[selectedLang].homeTabLabel"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <label class="">Chat tab label</label>
            <v-text-field
              v-model="widgetParameters[selectedLang].chatTabLabel"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <label class="">FAQs tab label</label>
            <v-text-field
              v-model="widgetParameters[selectedLang].faqsTabLabel"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <label class="">Services tab label</label>
            <v-text-field
              v-model="widgetParameters[selectedLang].servicesTabLabel"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <label class="">Voice tab label</label>
            <v-text-field
              v-model="widgetParameters[selectedLang].voiceTabLabel"
              outline
            ></v-text-field>
          </v-flex>

          <v-flex xs4></v-flex>

          <v-flex xs4>
            <label class="">FAQs title</label>
            <v-text-field
              class=""
              v-model="widgetParameters[selectedLang].faqsTitle"
              outline
            ></v-text-field>
          </v-flex>

          <v-flex xs4>
            <label class="">FAQs title</label>
            <v-text-field
              class=""
              v-model="widgetParameters[selectedLang].faqsPlaceholder"
              outline
            ></v-text-field>
          </v-flex>

          <v-flex xs4></v-flex>
           </v-layout>
      </div>
    </div>
    <div>
      <div>
        <v-layout row wrap>
          <!-- socialMediaColored -->
          <v-flex xs4>
            <label>Social media colored</label>
            <v-switch
              v-model="widgetParameters[selectedLang].socialMediaColored"
            />
          </v-flex>
          <!-- showSocialMediaInEndForm -->
          <v-flex xs4>
            <label>Display social media in end form</label>
            <v-switch
              v-model="widgetParameters[selectedLang].showSocialMediaInEndForm"
            />
          </v-flex>

          <v-flex xs4>
            <div class="btn-group" role="group" aria-label="Basic example">
              <label>Messenger link</label>
              <v-text-field
                class=""
                v-model="widgetParameters[selectedLang].facebookLink"
                outline
              ></v-text-field>
            </div>
          </v-flex>
          <v-flex xs4>
            <label>Whatsapp link</label>
            <v-text-field
              class=""
              v-model="widgetParameters[selectedLang].whatsappLink"
              outline
            ></v-text-field>
          </v-flex>

          <v-flex xs4>
            <div class="btn-group" role="group" aria-label="Basic example">
              <label>Twitter link</label>
              <v-text-field
                class=""
                v-model="widgetParameters[selectedLang].twitterLink"
                outline
              ></v-text-field>
            </div>
          </v-flex>

          <v-flex xs4>
            <div class="btn-group" role="group" aria-label="Basic example">
              <label>Instagram link</label>
              <v-text-field
                class=""
                v-model="widgetParameters[selectedLang].instagramLink"
                outline
              ></v-text-field>
            </div>
          </v-flex>

          <v-flex xs4>
            <div class="btn-group" role="group" aria-label="Basic example">
              <label>Linkedin link</label>
              <v-text-field
                class=""
                v-model="widgetParameters[selectedLang].linkedinLink"
                outline
              ></v-text-field>
            </div>
          </v-flex>

          <v-flex xs4>
            <div class="btn-group" role="group" aria-label="Basic example">
              <label>Tiktok link</label>
              <v-text-field
                class=""
                v-model="widgetParameters[selectedLang].tiktokLink"
                outline
              ></v-text-field>
            </div>
          </v-flex>

          <!-- youtubeLink -->
          <v-flex xs4>
            <div class="btn-group" role="group" aria-label="Basic example">
              <label>Youtube link</label>
              <v-text-field
                class=""
                v-model="widgetParameters[selectedLang].youtubeLink"
                outline
              ></v-text-field>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <hr />

    <div id="widget-home-screen" class="widget-section">
      <h3 class="primary-text text-bold">Home Screen</h3>

      <div class="publish-input-body">
        <v-layout row wrap>
          <v-flex xs4>
            <label>Use cookie consent</label>
            <v-switch
              v-model="widgetParameters[selectedLang].useCookieConsent"
            />
          </v-flex>
          <v-flex xs8 v-if="widgetParameters[selectedLang].useCookieConsent">
            <label>Cookie consent message</label>
            <quill-editor
              :id="'cookie-consent-editor-' + selectedLang"
              :key="'cookie-consent-editor-' + selectedLang"
              :value="widgetParameters[selectedLang].cookieConsentMessage"
              :options="cookieConsentEditorOptions"
              class="cookie-consent-editor"
              @change="onCookieConsentEditorChange"
            />
            <v-layout row wrap>
              <v-flex xs6>
                <label>Accept button label</label>
                <v-text-field
                  v-model="widgetParameters[selectedLang].cookieConsentAcceptLabel"
                  outline
                ></v-text-field>
              </v-flex>
              
              <v-flex xs6>
                <label>Reject button label</label>
                  <v-text-field
                    v-model="widgetParameters[selectedLang].cookieConsentRejectLabel"
                    outline
                  ></v-text-field>
              </v-flex>
            </v-layout>
            
          </v-flex>
          <v-flex xs12>
            <label>Home screen type</label>
            <v-radio-group
              v-model="widgetParameters[selectedLang].homeScreenBgType"
              row
              color="primary"
            >
              <v-radio label="Color" value="color" color="primary"></v-radio>
              <v-radio
                label="Gradient"
                value="gradient"
                color="primary"
              ></v-radio>
              <v-radio label="Image" value="image" color="primary"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex
            
            v-if="widgetParameters[selectedLang].homeScreenBgType === 'image'"
          >
            <label>Home screen background image</label>
            <image-input
              :small="true"
              :url="widgetParameters[selectedLang].homeScreenBackgroundImage"
              @onFileUpload="
                widgetParameters[selectedLang].homeScreenBackgroundImage =
                  $event.url
              "
              @onFileRemove="
                widgetParameters[selectedLang].homeScreenBackgroundImage = ''
              "
              types="image/png, image/jpg, image/jpeg"
              icon="botter-image-icon"
            ></image-input>
            <label>Home screen background image position</label>
            <v-layout row wrap style="gap: 6px;">
              <v-radio-group
                v-model="widgetParameters[selectedLang].homeScreenBackgroundImagePosition"
                row
                color="primary"
              >
                <v-radio label="Top" value="top" color="primary"></v-radio>
                <v-radio label="Bottom" value="bottom" color="primary"></v-radio>
                <v-radio label="Center" value="center" color="primary"></v-radio>
                <v-radio label="Left" value="left" color="primary"></v-radio>
                <v-radio label="Right" value="right" color="primary"></v-radio>
              </v-radio-group>
            </v-layout>
          </v-flex>

          <v-flex
            
            v-if="widgetParameters[selectedLang].homeScreenBgType === 'color'"
          >
            <label>Home screen color</label>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].homeScreenColor"
                  />
                </span>
              </template>
              <span>Home screen background color</span>
            </v-tooltip>
          </v-flex>
          <v-flex
            
            v-if="widgetParameters[selectedLang].homeScreenBgType === 'gradient'"
          >
            <label>Home screen gradient color</label>
            <v-layout row wrap style="gap: 6px;">
              <v-text-field
                v-model="widgetParameters[selectedLang].homeScreenGradientColor"
                outline
              ></v-text-field>
              <ColorPicker
                mode="gradient"
                v-model="widgetParameters[selectedLang].homeScreenGradientColor"
              />
            </v-layout>
            
          </v-flex>
        </v-layout>
      </div>
    </div>

    <hr />

    <div id="widget-chat" class="widget-section">
      <h3 class="primary-text text-bold">Widget Chat</h3>

      <div class="publish-input-body">
        <v-layout row wrap>
          <v-flex xs4>
            <label> Font</label>
            
            <v-autocomplete
              v-if="!widgetParameters[selectedLang].customFont"
              :items="googleFonts"
              item-value="family"
              item-text="family"
              v-model="widgetParameters[selectedLang].font"
              solo
              outline
            ></v-autocomplete>
            <v-text-field
              v-else
              v-model="widgetParameters[selectedLang].font"
              placeholder="Enter font name"
              solo
              outline
            ></v-text-field>
            <v-switch
              v-model="widgetParameters[selectedLang].customFont"
              label="Custom Font"
              hide-details
              class="mt-0 mb-2"
            ></v-switch>
          </v-flex>

          <v-flex xs4>
            <label>Font Size</label>
            <v-select
              v-model="widgetParameters[selectedLang].fontSize"
              :items="[11, 12, 13, 14, 15, 16]"
              type="number"
              outline
            ></v-select>
          </v-flex>
          <v-flex xs4>
            <label>Font Size on expand</label>
            <v-select
              v-model="widgetParameters[selectedLang].fontSizeOnExpand"
              :items="[11, 12, 13, 14, 15, 16, 18, 20, 22, 24]"
              type="number"
              outline
            ></v-select>
          </v-flex>

          <v-flex xs4>
            <label class="">Text bubbles colors</label>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].userSideColor"
                  />
                </span>
              </template>
              <span>User text background color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].userSideFontColor"
                  />
                </span>
              </template>
              <span>User text color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].chatBotAnswerColor"
                  />
                </span>
              </template>
              <span>Bot text background color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="
                      widgetParameters[selectedLang].chatBotAnswerFontColor
                    "
                  />
                </span>
              </template>
              <span>Bot text color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].buttonsColor"
                  />
                </span>
              </template>
              <span>Buttons font color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].hyperlinkColor"
                  />
                </span>
              </template>
              <span>Hyperlink font color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="
                      widgetParameters[selectedLang].buttonsBackgroundColor
                    "
                  />
                </span>
              </template>
              <span>Buttons background color</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="widgetParameters[selectedLang].buttonsBorderColor"
                  />
                </span>
              </template>
              <span>Buttons border color</span>
            </v-tooltip>
          </v-flex>

          <v-flex xs12>
            <label for="" class="mt-4">Chat bubble shape</label>
            <v-btn-toggle
              v-model="widgetParameters[selectedLang].chatBubble"
              class="chat-bubbles"
            >
              <v-btn
                v-for="(btn, index) in chatBubbleOptions"
                :class="btn.class"
                :value="btn.value"
                :key="index"
              >
                {{ btn.name }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>

          <v-flex xs4>
            <label class="d-block">Avatar logo</label>
            <image-input
              :small="true"
              :url="widgetParameters[selectedLang].botAvatar"
              @onFileUpload="
                widgetParameters[selectedLang].botAvatar = $event.url
              "
              @onFileRemove="widgetParameters[selectedLang].botAvatar = ''"
              types="image/png, image/jpg, image/jpeg"
              icon="botter-image-icon"
            ></image-input>
          </v-flex>

          <v-flex xs4>
            <div class="btn-group" role="group" aria-label="Basic example">
              <label>Avatar name</label>
              <v-text-field
                class=""
                v-model="widgetParameters[selectedLang].botName"
                outline
              ></v-text-field>
            </div>
          </v-flex>

          <v-flex xs4>
            <label for="">Avatar full width</label>
            <v-switch
              v-model="widgetParameters[selectedLang].botAvatarHasFullWidth"
            />
          </v-flex>

          <v-flex xs4>
            <label class="d-block">Avatar logo type</label>
            <v-radio-group
              v-model="widgetParameters[selectedLang].botAvatarColorType"
              row
              color="primary"
            >
              <v-radio label="White" value="white" color="primary"></v-radio>
              <v-radio
                label="Colored"
                color="primary"
                value="colored"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs4>
            <label class="d-block">Avatar background type</label>
            <v-radio-group
              v-model="widgetParameters[selectedLang].avatarType"
              row
              color="primary"
            >
              <v-radio label="Rounded" value="circle" color="primary"></v-radio>
              <v-radio
                label="Transparent"
                color="primary"
                value="square"
              ></v-radio>
            </v-radio-group>
          </v-flex>

          <v-flex xs4>
            <label class="d-block">Avatar background</label>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <swatches
                    show-fallback
                    class="inline-block"
                    row-length="5.5"
                    shapes="circles"
                    show-border
                    popover-x="left"
                    v-model="
                      widgetParameters[selectedLang].avatarBackgroundColor
                    "
                  />
                </span>
              </template>
              <span>Avatar background</span>
            </v-tooltip>
          </v-flex>

          <v-flex xs4>
            <label class="d-block">Agent default avatar</label>
            <image-input
              :small="true"
              :url="widgetParameters[selectedLang].agentDefaultAvatar"
              @onFileUpload="
                widgetParameters[selectedLang].agentDefaultAvatar = $event.url
              "
              @onFileRemove="
                widgetParameters[selectedLang].agentDefaultAvatar = ''
              "
              types="image/png, image/jpg, image/jpeg"
              icon="botter-image-icon"
            ></image-input>
          </v-flex>

          <v-flex xs4>
            <label class="">User chat placeholder</label>
            <v-text-field
              class=""
              v-model="widgetParameters[selectedLang].inputPlaceHolder"
              outline
            ></v-text-field>
          </v-flex>

          <v-flex xs4> </v-flex>

          <v-flex xs4>
            <label class="d-block">Show location sharing</label>
            <v-switch
              v-model="widgetParameters[selectedLang].showLocationLocator"
              label="Show Location locator"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
          </v-flex>

          <v-flex xs4 v-if="widgetParameters[selectedLang].showLocationLocator">
            <label class="">Google maps API key</label>
            <v-text-field
              class=""
              v-model="widgetParameters[selectedLang].googleMapApiKey"
              outline
            ></v-text-field>
          </v-flex>

          <v-flex xs4>
            <label class="d-block">Prevent buttons multiple click</label>
            <v-switch
              v-model="widgetParameters[selectedLang].buttonsSingleClick"
              label="Prevent user to click multiple times on hero and gallery card buttons"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
          </v-flex>

          <v-flex xs4>
            <label class="d-block">Disable Text Input</label>
            <v-switch
              v-model="widgetParameters[selectedLang].disableTextInput"
              label="Disable user text input"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
          </v-flex>

          <v-flex xs6>
            <div class="btn-group" role="group" aria-label="Basic example">
              <label class="">Message Notification Sound URL</label>
              <v-text-field
                class=""
                v-model="widgetParameters[selectedLang].messageSound"
                outline
              ></v-text-field>
              <image-input
                :url="widgetParameters[selectedLang].messageSound"
                @onFileUpload="
                  widgetParameters[selectedLang].messageSound = $event.url
                "
                @onFileRemove="widgetParameters[selectedLang].messageSound = ''"
                type="audio"
                types="audio/mp3, audio/ogg, audio/wav, audio/mpeg"
                icon="botter-audio-icon"
              />
            </div>
          </v-flex>
          <v-flex xs6>
            <label class="">Typing Notification Sound URL</label>
            <v-text-field
              class=""
              v-model="widgetParameters[selectedLang].typingSound"
              outline
            ></v-text-field>
            <image-input
              :url="widgetParameters[selectedLang].typingSound"
              @onFileUpload="
                widgetParameters[selectedLang].typingSound = $event.url
              "
              @onFileRemove="widgetParameters[selectedLang].typingSound = ''"
              type="audio"
              types="audio/mp3, audio/ogg, audio/wav, audio/mpeg"
              icon="botter-audio-icon"
            />
          </v-flex>
        </v-layout>
      </div>
    </div>

    <hr />

    <div id="#widget-demo" class="widget-section">
      <h3 class="primary-text text-bold">Demo Parameters</h3>
      <div class="publish-input-body">
        <v-layout>
          <v-flex xs6>
            <label class="d-block">Demo background</label>
            <image-input
              :validation="false"
              :can-remove="true"
              :url="widgetParameters[selectedLang].demoBackground"
              @onFileUpload="
                widgetParameters[selectedLang].demoBackground = $event.url
              "
              @onFileRemove="widgetParameters[selectedLang].demoBackground = ''"
              type="image"
              types="image/png, image/jpg, image/jpeg, image/gif"
              icon="botter-image-icon"
            ></image-input>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <hr />

    <div id="widget-recaptcha" class="widget-section">
      <h3 class="primary-text text-bold">reCAPTCHA Settings</h3>
      <div class="publish-input-body">
        <v-layout row wrap>
          <v-flex xs12>
            <v-switch
              v-model="widgetParameters[selectedLang].reCAPTCHA_enabled"
              label="Enable reCAPTCHA"
              color="primary"
              class="d-block hide-messages"
            ></v-switch>
          </v-flex>
          <v-flex xs6 v-if="widgetParameters[selectedLang].reCAPTCHA_enabled">
            <label>Site Key</label>
            <v-text-field
              v-model="widgetParameters[selectedLang].reCAPTCHA_site_key"
              outline
              placeholder="Enter your reCAPTCHA site key"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="widgetParameters[selectedLang].reCAPTCHA_enabled">
            <label>Action Name</label>
            <v-text-field
              v-model="widgetParameters[selectedLang].reCAPTCHA_action"
              outline
              placeholder="e.g. widget_interaction"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            v-if="recaptchaErrors.length"
          >
            <v-alert
              :value="true"
              type="error"
              dismissible
              @input="recaptchaErrors = []"
            >
              <div v-for="(err, i) in recaptchaErrors" :key="i">{{ err }}</div>
            </v-alert>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div class="text-left mt-5">
      <a
        @click="publishWidget"
        class="v-btn v-btn v-btn--large v-btn--round theme--light primary"
        >Publish And Generate Widget</a
      >
      <a
        @click="createDemoLink"
        target="_blank"
        class="v-btn v-btn v-btn--large v-btn--round theme--light primary"
        >Get Widget Link</a
      >
      <a
        @click="createNewWidgetLink"
        target="_blank"
        class="v-btn v-btn v-btn--large v-btn--round theme--light primary"
        >Get New Widget Link</a
      >
    </div>

    <v-tabs
      v-if="generated_widget_card"
      v-model="activeTab"
      color="white"
      id="generated_widget_card"
      light
      class="widget-code"
      slider-color="gray"
      right
    >
      <v-tab href="#tab-2"> Iframe </v-tab>
      <v-tab-item value="tab-2" class="">
        <p>{{ genratedIframe }}</p>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import _ from "lodash";
import Swatches from "vue-swatches";
import env from "../../utils/env";
import langIso from "../../utils/lang-iso";
import imageInput from "../block-build/blocks/block-cards/common-inner-blocks/image-uploader-dropzone";
import allGoogleFonts from "./googleFonts";
import { quillEditor } from "vue-quill-editor";
import ColorPicker from "vue2-color-picker-gradient";
import "vue2-color-picker-gradient/dist/index.css";
import langSelector from "./langSelector";
export default {
  name: "designForm",
  components: {
    Swatches,
    imageInput,
    langSelector,
    quillEditor,
    ColorPicker,
  },
  data() {
    return {
      langIso,
      langList: [],
      activeTab: 0,
      selectedLang: "en_US",
      cookieConsentEditorOptions: {
        placeholder: "Write the cookie consent message",
        modules: {
          toolbar: [["bold", "italic", "underline"], ["link"]],
        },
      },
      offLineMessageAppearanceList: [
        {
          name: "Off",
          value: "off",
        },
        {
          name: "Appear once",
          value: "once",
        },
        {
          name: "Appear every-time",
          value: "every-time",
        },
      ],
      chatBubbleIconOptions: [
        {
          name: "Circle",
          value: "circle",
          class: "btn btn-circle",
        },
        {
          name: "Rounded",
          value: "rounded",
          class: "btn btn-rounded active",
        },
        {
          name: "Partially Rounded",
          value: "partially-rounded",
          class: "btn btn-partially-rounded",
        },
        {
          name: "Transparent",
          value: "transparent",
          class: "btn btn-transparent",  
        },
      ],
      chatBubbleOptions: [
        {
          name: "Solid",
          value: "solid",
          class: "btn btn-solid",
        },
        {
          name: "Rounded",
          value: "rounded",
          class: "btn btn-rounded active",
        },
        {
          name: "Curvey",
          value: "curvey",
          class: "btn btn-curvey",
        },
      ],
      generated_widget_card: false,
      googleFonts: [],
      generatedWidget: "",
      generatedWidgetSaved: "",
      genratedIframe: "",
      generatedWidgetAndroid: "",
      generatedWidgetIOS: "",
      settings: {},
      recaptchaErrors: [],
      widgetParameters: {
        en_US: {
          reCAPTCHA_enabled: false,
          reCAPTCHA_site_key: "",
          reCAPTCHA_action: "widget_interaction",
          header: "Chat with botter",
          subHeader:
            "We’re here to answer your questions about Company. Ask us anything!",
          offlineMessage:
            "We’re here to answer your questions about Company. Ask us anything!",
          botName: "BOTTER",
          startButtonLabel: "Start now",
          endButtonLabel: "End chat",
          inputPlaceHolder: "Write a reply",
          lang: "en_US",
          mainColor: "#473FB3",
          userSideColor: "#473FB3",
          userSideFontColor: "white",
          headerColor: "#473FB3",
          headerFontColor: "white",
          chatBotAnswerColor: "#eaf0f7",
          chatBotAnswerFontColor: "#000",
          bubbleButtonColor: "#473FB3",
          bubbleButtonSize: 60,
          avatarBackgroundColor: "#eee",
          chatBubbleIconShape: "circle",
          chatBubbleShape: "partially-rounded",
          buttonsColor: "#473FB3",
          hyperlinkColor: "#200fe5",
          buttonsBackgroundColor: "#fff",
          buttonsBorderColor: "#473FB3",
          typingSound: "",
          messageSound: "",
          logo: "https://portal.botter.live/img/logo.8878de79.png",
          botAvatar: "https://portal.botter.live/img/logo.8878de79.png",
          agentDefaultAvatar:
            "https://prod-api.botter.live/uploads/2020-08-10/1597053363.png",
          openBubbleImage: "https://portal.botter.live/img/logo.8878de79.png",
          closeBubbleImage:
            "https://botter-prod.fra1.digitaloceanspaces.com/2025-01-29/close-icon.png",
          logoColorType: "white",
          botAvatarColorType: "colored",
          botAvatarHasFullWidth: false,
          openBubbleImageColorType: "white",
          openBubbleImageFullWidth: false,
          offLineMessageBackgroundColor: "#fff",
          offLineMessageFontColor: "#000",
          offLineMessageAppearance: "once",
          avatarType: "circle",
          customFont: false,
          font: "Roboto",
          fontSize: 14,
          fontSizeOnExpand: 14,
          chatBubble: "curvey",
          direction: "ltr",
          position: "right",
          hideFaqs: false,
          hideForms: false,
          hideVoiceNoteRecorder: false,
          hideVoiceCall: false,
          hideBotter: false,
          hideShareFile: false,
          hideHomeNav: false,
          displayIntroButtons: false,
          rememberUser: true,
          socialMediaColored: false,
          facebookLink: "",
          twitterLink: "",
          whatsappLink: "",
          instagramLink: "",
          linkedinLink: "",
          tiktokLink: "",
          youtubeLink: "",
          demoBackground: "",
          showSocialMediaInEndForm: false,
          showLocationLocator: false,
          googleMapApiKey: "",
          buttonsSingleClick: false,
          disableTextInput: false,
          whatsAppChatButtonLink: "",
          whatsAppMandatory: false,
          whatsAppBtnColor: "#01AF9C",
          webBtnColor: "#FFC108",
          whatsAppBtnImg:
            "https://botter-prod.s3.eu-central-1.amazonaws.com/2021-06-23/whatsapp.png",
          webBtnImg:
            "https://botter-prod.s3.eu-central-1.amazonaws.com/2021-06-23/web.png",
          faqsTitle: "Find an answer your self",
          faqsPlaceholder: "Search FAQs",
          homeTabLabel: "Home",
          chatTabLabel: "Chat",
          faqsTabLabel: "FAQs",
          servicesTabLabel: "Services",
          voiceTabLabel: "Voice",
          introButtonsBackground: "#fff",
          introButtonsColor: "#000",
          useCookieConsent: false,
          cookieConsentMessage: "",
          cookieConsentAcceptLabel: "Accept",
          cookieConsentRejectLabel: "Reject",
          homeScreenBgType: "color",
          homeScreenBackgroundImage: "",
          homeScreenGradientColor: "",
          homeScreenColor: "#473FB3",
          homeScreenBackgroundImagePosition: "center",
        },
      },
    };
  },
  beforeMount() {},
  async mounted() {
    await this.getWidgetSettings();
    await this.getGoogleFonts();
    await this.getSettings();
  },
  methods: {
    onCookieConsentEditorChange({ html }) {
      this.widgetParameters[this.selectedLang].cookieConsentMessage =
        html === "<p><br></p>" ? "" : html || "";
    },
    async getGoogleFonts() {
      // const response = await this.$http_without_base.get(
      //   "https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBr6nsPTXn2O1RTMMt4OTaY9ofFh6QEgWs"
      // );

      this.googleFonts = allGoogleFonts;
    },
    addNewLang(lang) {
      this.widgetParameters[lang.code] = _.cloneDeep(
        this.widgetParameters.en_US
      );
    },
    async getSettings() {
      const response = await this.$http_bot.get("/settings/");

      this.settings = response.data;
    },
    async saveWidgetSettings() {
      await this.$http_session_manager.put(
        `bots/${this.$store.state.bot.botId}/widget-settings`,
        this.widgetParameters
      );
    },
    async getWidgetSettings() {
      const response = await this.$http_session_manager.get(
        `bots/${this.$store.state.bot.botId}/widget-settings?all=true`
      );

      if (response.data) {
        for (let lang in response.data) {
          if (response.data.hasOwnProperty(lang)) {
            let langObj = this.langIso.find((itemLang) => {
              return itemLang.code === lang;
            });
            if (langObj) {
              this.langList.push(langObj);
            }
          }
        }

        if (response.data.reCAPTCHA_enabled === undefined) {
          response.data.reCAPTCHA_enabled = false;
        }
        if (response.data.reCAPTCHA_site_key === undefined) {
          response.data.reCAPTCHA_site_key = "";
        }
        if (response.data.reCAPTCHA_action === undefined) {
          response.data.reCAPTCHA_action = "widget_interaction";
        }

        this.widgetParameters = response.data;
        this.fillMissingData();
      } else {
        this.langList.push({ code: "en_US", name: "English" });
      }
    },
    async createDemoLink() {
      if (!this.validateRecaptcha()) return;
      await this.saveWidgetSettings();
      let queryUrl = `bot_id=${this.botId}&&botterLang=${this.selectedLang}`;
      window.open(`${this.widgetUrl}/?${queryUrl}`, "_blank");
    },
    async createNewWidgetLink() {
      if (!this.validateRecaptcha()) return;
      await this.saveWidgetSettings();
      let queryUrl = `id=${this.botId}&lang=${this.selectedLang}&mode=dev`;
      window.open(`${this.newWidgetUrl}/?${queryUrl}`, "_blank");
    },
    async publishWidget() {
      if (!this.validateRecaptcha()) return;
      await this.saveWidgetSettings();
      let widgetParameters = JSON.stringify(
        this.widgetParameters[this.selectedLang]
      );
      let widgetJsFile =
        '<script src="' + env.WIDGET_IFRAME_URL + '/app.js"></scr' + "ipt>";
      let iframeJsFile =
        '<script src="' +
        env.WIDGET_IFRAME_URL +
        '/iframe/script.js"></scr' +
        "ipt>";
      this.generatedWidget = `
                    <div id="botter-widget"
                        widget_parameters='${widgetParameters}'
                        bing-subscription-key="ca86942144d34294a7dfd3afddd8dd50"
                        bot_id="${this.botId}"
                        locale="${this.selectedLang}" >
                         <div id=botter-widget-app></div>
                         <link rel=stylesheet href=https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css>
                    </div>
                    ${widgetJsFile}
                `;
      this.generatedWidgetSaved = `
                       <div id="botter-widget"
                        bot_id="${this.botId}"
                        locale="${this.selectedLang}" >
                         <div id=botter-widget-app></div>
                         <link rel=stylesheet href=https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css>
                    </div>
                    ${widgetJsFile}
                `;
      this.genratedIframe = `
                    <link rel="stylesheet" type="text/css" href="${env.WIDGET_IFRAME_URL}/iframe/style.css">
                    <iframe allowfullscreen src="${env.WIDGET_IFRAME_URL}/?bot_id=${this.botId}&&botterLang=${this.selectedLang}" allow="camera;microphone" class="" id="botter-iframe"></iframe>
                    ${iframeJsFile}
                `;
      this.generated_widget_card = true;
      setTimeout(function () {
        document.getElementById("generated_widget_card").scrollIntoView();
      }, 1000);
      this.$store.dispatch(
        "setWidgetSettings",
        this.widgetParameters[this.selectedLang]
      );
    },
    validateRecaptcha() {
      const errors = [];
      const wp = this.widgetParameters[this.selectedLang];
      if (wp.reCAPTCHA_enabled) {
        if (!wp.reCAPTCHA_site_key || !wp.reCAPTCHA_site_key.trim()) {
          errors.push("Site Key is required when reCAPTCHA is enabled");
        }
        if (!wp.reCAPTCHA_action || !wp.reCAPTCHA_action.trim()) {
          errors.push("Action Name is required when reCAPTCHA is enabled");
        }
      }
      this.recaptchaErrors = errors;
      return errors.length === 0;
    },
    fillMissingData() {
      const current = this.widgetParameters[this.selectedLang];
      if (current.reCAPTCHA_enabled === undefined) {
        current.reCAPTCHA_enabled = false;
      }
      if (current.reCAPTCHA_site_key === undefined) {
        current.reCAPTCHA_site_key = "";
      }
      if (current.reCAPTCHA_action === undefined) {
        current.reCAPTCHA_action = "widget_interaction";
      }
      if (!current.offLineMessageFontColor) {
        this.widgetParameters[this.selectedLang].offLineMessageFontColor =
          "#000";
      }

      if (!this.widgetParameters[this.selectedLang].offLineMessageAppearance) {
        this.widgetParameters[this.selectedLang].offLineMessageAppearance =
          "once";
      }

      if (!this.widgetParameters[this.selectedLang].whatsAppBtnColor) {
        this.widgetParameters[this.selectedLang].whatsAppBtnColor = "#01AF9C";
      }
      if (!this.widgetParameters[this.selectedLang].webBtnColor) {
        this.widgetParameters[this.selectedLang].webBtnColor = "#FFC108";
      }
      if (!this.widgetParameters[this.selectedLang].whatsAppBtnImg) {
        this.widgetParameters[this.selectedLang].whatsAppBtnImg =
          "https://botter-prod.s3.eu-central-1.amazonaws.com/2021-06-23/whatsapp.png";
      }
      if (!this.widgetParameters[this.selectedLang].webBtnImg) {
        this.widgetParameters[this.selectedLang].webBtnImg =
          "https://botter-prod.s3.eu-central-1.amazonaws.com/2021-06-23/web.png";
      }
      if (!this.widgetParameters[this.selectedLang].buttonsColor) {
        this.widgetParameters[this.selectedLang].buttonsColor =
          this.widgetParameters[this.selectedLang].mainColor;
      }
      if (!this.widgetParameters[this.selectedLang].hyperlinkColor) {
        this.widgetParameters[this.selectedLang].hyperlinkColor = '#200fe5'
      }
      if (!this.widgetParameters[this.selectedLang].buttonsBackgroundColor) {
        this.widgetParameters[this.selectedLang].buttonsBackgroundColor =
          "#fff";
      }
      if (!this.widgetParameters[this.selectedLang].buttonsBorderColor) {
        this.widgetParameters[this.selectedLang].buttonsBorderColor =
          this.widgetParameters[this.selectedLang].mainColor;
      }
      if (!this.widgetParameters[this.selectedLang].faqsTitle) {
        this.widgetParameters[this.selectedLang].faqsTitle =
          "Find an answer your self";
      }
      if (!this.widgetParameters[this.selectedLang].faqsPlaceholder) {
        this.widgetParameters[this.selectedLang].faqsPlaceholder =
          "Search FAQs";
      }
      if (!this.widgetParameters[this.selectedLang].homeTabLabel) {
        this.widgetParameters[this.selectedLang].homeTabLabel = "Home";
      }
      if (!this.widgetParameters[this.selectedLang].chatTabLabel) {
        this.widgetParameters[this.selectedLang].chatTabLabel = "Chat";
      }
      if (!this.widgetParameters[this.selectedLang].faqsTabLabel) {
        this.widgetParameters[this.selectedLang].faqsTabLabel = "FAQs";
      }
      if (!this.widgetParameters[this.selectedLang].servicesTabLabel) {
        this.widgetParameters[this.selectedLang].servicesTabLabel = "Services";
      }
      if (!this.widgetParameters[this.selectedLang].voiceTabLabel) {
        this.widgetParameters[this.selectedLang].voiceTabLabel = "Voice";
      }
      if (!this.widgetParameters[this.selectedLang].useCookieConsent) {
        this.widgetParameters[this.selectedLang].useCookieConsent = false;
      }
      if (!this.widgetParameters[this.selectedLang].cookieConsentAcceptLabel) {
        this.widgetParameters[this.selectedLang].cookieConsentAcceptLabel = "Accept";
      }
      if (!this.widgetParameters[this.selectedLang].cookieConsentRejectLabel) {
        this.widgetParameters[this.selectedLang].cookieConsentRejectLabel = "Reject";
      }
      if (!this.widgetParameters[this.selectedLang].homeScreenBgType) {
        this.widgetParameters[this.selectedLang].homeScreenBgType = "color";
      }
      if (!this.widgetParameters[this.selectedLang].homeScreenColor) {
        this.widgetParameters[this.selectedLang].homeScreenColor =
          this.widgetParameters[this.selectedLang].headerColor;
      }
    },
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
    widgetUrl() {
      return env.WIDGET_IFRAME_URL;
    },
    newWidgetUrl() {
      return process.env.VUE_APP_NEW_WIDGET_URL;
    },
    widgetParametersState() {
      return this.widgetParameters[this.selectedLang];
    },
  },
  watch: {
    widgetParametersState: {
      async handler(state) {
        this.$emit("updatePreview", state);
        let wn = document.getElementById("botter-iframe").contentWindow;
        wn.postMessage(
          {
            type: "reload",
            value: true,
          },
          "*"
        );
        await this.saveWidgetSettings();
      },
      deep: true,
    },
    selectedLang() {
      this.fillMissingData();
      this.widgetParameters[this.selectedLang].lang = this.selectedLang;
    },
  },
};
</script>

<style scoped>
hr {
  border-top: 1px solid #eee;
}
label {
  margin-bottom: 10px;
  margin-top: 50px;
  display: block;
  font-size: 14px;
  color: black;
}
.publish-input-body {
  padding: 5px 0;
}
.card-header {
  padding: 0;
}
.card-header h5 {
  padding: 1rem 1.25rem;
  font-size: 1.2em;
  cursor: pointer;
}
.btn-group .btn {
  margin-right: 20px;
  border: 1px solid #e6e6e6;
  position: relative;
  padding: 12px 30px;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.42857;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 0;
  cursor: pointer;
  background: white;
  border-radius: 0.2rem;
  outline: 0;
  transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1),
    background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: box-shadow, transform;
}
.btn-group .active {
  background: #4f47b6;
  color: white;
  border: 1px solid #4f47b6;
}
.btn-solid {
  border-radius: 2px !important;
}
.btn-rounded {
  border-radius: 20px 0 20px 20px !important;
}
.btn-curvey {
  border-radius: 5px 0 5px 5px !important;
}
.btn-publish {
  width: 100%;
  font-size: 20px;
}
.generated-widget {
  text-transform: initial;
}
.generated-widget p {
  word-break: break-all;
}
</style>

<style>
@import url("~vue-swatches/dist/vue-swatches.min.css");
.cookie-consent-editor .ql-container {
  min-height: 200px;
}

.cookie-consent-editor .ql-editor {
  min-height: 158px;
}

.vue-swatches__trigger {
  width: 30px !important;
  height: 30px !important;
}
.active-switch-inline {
  padding-top: 8px !important;
}

.dimmer.dialog {
}
.vue-swatches__container:not(.vue-swatches--inline) {
  max-height: 350px !important;
}

.vue-swatches__swatch {
  position: relative;
  font-size: 0;
  width: 15px !important;
  height: 15px !important;
  padding: 5px !important;
  margin: 5px !important;
  border: none;
  box-shadow: none !important;
}
.vue-swatches__check__wrapper {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>

<style lang="scss">
.vue-swatches {
  display: inline-block;
  margin-right: 10px;
}
.publish-widget .v-text-field--outline .v-input__control > .v-input__slot {
  background: white !important;
  border: 1px solid #e6e6e6 !important;
}
.publish-widget .v-input--selection-controls.v-input .v-label {
  margin-bottom: 0;
  font-size: 14px;
  color: black;
}
.widget-code p {
  word-break: break-all;
  border: 1px solid #aaaaaa;
  border-radius: 10px;
  padding: 15px;
}
.vue-swatches__trigger {
  border: 1px solid #eee;
}
.widget-section {
  margin: 50px 0;
}
.vue-swatches__container:not(.vue-swatches--inline) {
  width: 300px;
}

.chat-bubbles {
  .v-btn {
    margin-right: 10px;
  }
  .v-btn:not(.v-btn--active) {
    background: white !important;
    color: black !important;
    border: 1px solid #e6e6e6 !important;
  }
}

.chat-bubbles-icon .v-btn{
  width: 60px !important;
  height: 60px !important;
  margin-inline: 6px;
  border: 2px dashed #ccc !important;
  padding: 0 !important;
  
  .v-btn__content{
    max-width: 60px;
    white-space: wrap !important;
    padding: 0 !important;
  }
  &.btn-circle{
    border-radius: 100% !important;
  }
  &.btn-rounded{
    border-radius: 16px !important;
  }
  &.btn-partially-rounded{
    border-radius: 16px 0px 16px 16px !important;
  }
  &.btn-transparent{
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    width: 80px !important;
    &>div{
      color: black !important;
      max-width: 80px !important;
      display: inline-block !important;
    }
  }

  &.v-btn--active {
  }
}
</style>
